import { Fancybox } from "@fancyapps/ui";
import { attachProductToForm } from "./catalog-request";
import { listenForm } from "./forms";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

window.addEventListener('load', function () {
    let elements = document.querySelectorAll('.js-fancybox-button')
    elements.forEach(function (item) {
        item.addEventListener('click', function (e) {
            window.catalogButton = item;
            return
        })
        let id = item.dataset.fancyboxId;
        Fancybox.bind("[data-fancybox-id='" + id + "']", {
            touch: false,
            Carousel: {
                Navigation: false,
            },
            Thumbs : {
                showOnStart: false
            },
            on: {
                done: (fancybox) => {
                    let form = fancybox.container.querySelector('.is-selected .js-form')
                    attachProductToForm(window.catalogButton, form)
                },
                reveal: (fancybox) => {
                    let form = fancybox.container.querySelector('.is-selected .js-form')
                    listenForm(form)
                }
            }
        });
    })


    let productsGalleries = document.querySelectorAll('.catalog-list-item-pics');
    productsGalleries.forEach(function (item) {
        let id = item.id;
        Fancybox.bind('#' + id + ' img', {
            groupAll: true
        })
    })
})

